import { adminRouteAccess } from '@rsos/capstone/src/constants/adminRouteAccess';
import { hasAccess, type AccessContext } from '@rsos/hooks/hasAccess';
import type { SideBarMenuItem } from './types';

/**
 * Whether a sidebar item should be rendered.
 *
 * The item carries no access rules of its own: they are looked up from
 * adminRouteAccess by the item's `link` and evaluated by the same `hasAccess`
 * predicate the route guards use, which is what keeps nav visibility and route
 * access from drifting apart.
 *
 * @param sidebarItem sidebar item, whose `link` keys into adminRouteAccess
 * @param context the current user's permissions, flags, capabilities and application
 * @returns boolean determining if eligible for rendering
 */
export const shouldSideBarItemRender = (
  sidebarItem: Pick<SideBarMenuItem, 'link'>,
  context: AccessContext,
): boolean => hasAccess(adminRouteAccess[sidebarItem.link], context);
